import authServiceImpl from '../services/auth-service';
import type { AuthService } from './contracts';

export type { Credentials, AuthService, SessionIdentity } from './contracts';
export { default as AuthProvider } from '../components/auth-provider';
export { default as Auth0TokenBridge } from '../components/auth0-token-bridge';
export { default as LoginPage } from '../components/login-form';
export { default as useSessionId } from '../components/session-provider';
export { default as useSessionIdentity } from '../components/use-session-identity';
export { default as Auth0Page } from '../pages/auth0-page';
export { default as BbgPage } from '../pages/bbg-page';
export { default as TokenExchangePage } from '../pages/token-exchange-page';
export const authService: AuthService = authServiceImpl;
